export {
  VisuallyHidden,
  //
  Root,
} from './VisuallyHidden';
export type { VisuallyHiddenProps } from './VisuallyHidden';
